import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";

const initState = {
  invoiceNo: null,
  status: null,
  date: null,
  paymentCategory: null,
};

export const PostReviewData = {
  name: "RecordListForm",
  initialState: initState,
  section: [
    {
      title: "RecordListForm",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "RecordListForm",
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="form-card row"></div>,
          fields: [
            {
              id: "topics",
              label: "Topics",
              Field_Name: "Topics",
              fieldType: FormFieldTypes.SELECT,
              dataField: "topics",
              fieldSetting: {
                placeholder: "Select",
                options: [],
              },
              style: {
                containerCss: "col-lg-12 col-md-12 validation-left-0 ",
              },
            },
            {
              id: "metaTitle",
              label: "Meta Title",
              Field_Name: "MetaTitle",
              fieldType: FormFieldTypes.INPUT,
              dataField: "metaTitle",
              fieldSetting: {
                allowSpace: false,
              },
              style: {
                containerCss: "col-lg-12 col-md-12",
              },
            },
            {
              id: "metaKeyword",
              label: "Meta Keywords",
              Field_Name: "MetaTitle",
              fieldType: FormFieldTypes.INPUT,
              dataField: "metaKeyword",
              fieldSetting: {
                allowSpace: false,
              },
              style: {
                containerCss: "col-lg-12 col-md-12",
              },
            },
            {
              id: "metaDescription",
              label: "Meta Description",
              Field_Name: "MetaDescription",
              fieldType: FormFieldTypes.TEXTAREA,
              dataField: "metaDescription",
              fieldSetting: {
                allowSpace: false,
              },
              style: {
                containerCss: "col-lg-12 col-md-12",
              },
            },
            {
              id: "visibility",
              label: "FoVisibilityrmat",
              Field_Name: "Visibility",
              fieldType: FormFieldTypes.RADIOBUTTON,
              dataField: "visibility",
              fieldSetting: {
                allowSpace: true,
                options: [
                  { value: "hidden", label: "Hidden" },
                  { value: "member", label: "Member" },
                  { value: "non-member", label: "Non-Member" },
                ],
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-12 radioStyle col-md-4 ",
              },
            },
          ],
        },
      ],
    },
  ],
};
